import { render, staticRenderFns } from "./orgCoordinate.vue?vue&type=template&id=1f4feda6&scoped=true&"
import script from "./orgCoordinate.vue?vue&type=script&lang=js&"
export * from "./orgCoordinate.vue?vue&type=script&lang=js&"
import style0 from "./orgCoordinate.vue?vue&type=style&index=0&id=1f4feda6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4feda6",
  null
  
)

export default component.exports